module.exports = __webpack_public_path__ + "static/img/states-icon-in-button.253bf31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/states-icon-in-button.svg
// module id = y1wA
// module chunks = 0